module.exports = __webpack_public_path__ + "img/Frame 5118.6f22eb45.jpg";